import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { ItemStockService } from '../../../service/item-stock/item-stock.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { TypeStockService } from '../../../service/type-stock/type-stock.service';

@Component({
  selector: 'app-root',
  templateUrl: 'wa6030.component.html',
  styleUrls: ['wa6030.component.scss']
})
export class Wa6030Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA6030:商品別在庫照会';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public config = config;

  public ownerId: number;
  public ownerResult: any;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  private errorInfo = '';

  private gridHelper: AgGridHelper;
  @ViewChild('gridView')
  gridView: ElementRef;

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private isEnableGo6010Button = false;

  private isShowSearchBlock = true;
  private isOwnerSearchNone = false;

  public stockTypes: any[];
  public stockType = '';
  private itemCd = '';
  private stockTypeCls = '';
  private isEnableClearFilter = false;
  private searchValue1Cls = '';
  private searchKeyOwnerTx = null;

  constructor(private router: Router, private itemStockService: ItemStockService, private commonService: CommonService, private dialogsService: DialogsService, private typeStockService: TypeStockService) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      shohwLoadingOverlay: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa6030_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }

        this.gridHelper.onGridReady();
        this.gridHelper.renderGridCheckboxImage();
        this.gridHelper.autoTogglePagination();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.gridHelper.renderGridCheckboxImage();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();

        this.gridHelper.autoTogglePagination();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.gridHelper.renderGridCheckboxImage();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.isEnableGo6010Button = this.gridOptions.api.getSelectedRows().length == 1;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: "", width: 30, cellClass: ['tc', 'cl_w', 'noCellFocus'],
        headerCheckboxSelection: false, checkboxSelection: true, suppressMenu: true,
        pinned: 'left'
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 120),
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        suppressMenu: true,
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 250),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '在庫区分',
        field: 'typestockTx',
        width: this.getColumnWidth('typestockTx', 80),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '単位',
        field: 'unitTx',
        width: this.getColumnWidth('unitTx', 80),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入数',
        field: 'amountNr',
        width: this.getColumnWidth('amountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '在庫数',
        field: 'stockNr',
        width: this.getColumnWidth('stockNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当可能数',
        field: 'pstockNr',
        width: this.getColumnWidth('pstockNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当済数',
        field: 'cstockNr',
        width: this.getColumnWidth('cstockNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 250),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
      this.searchKeyOwnerTx = selectedOwner.ownerTx;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa6030_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa6030_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      localStorage.setItem(`wa6030_${column.colId}_idx`, `${idx}`);
      idx++;
    }
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    // this.gridOptions.onRowDoubleClicked = this.onView.bind(this);

    this.gridOptions.api.setRowData([]);
    this.typeStockService
      .get()
      .then(response => {
        console.log(response);
        this.stockTypes = response['typestocks'];
      })
      .catch(error => {
        this.stockTypes = [];
      });
  }

  onView(event) {
    console.log(event.data.itemId);
    sessionStorage.setItem('wa6030_itemId', event.data.itemId);
    this.router.navigate(['wa6010']);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  onSubmit() {
    this.errorInfo = '';
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    this.itemStockService
      .get(this.ownerId)
      .then(outputJson => {
        
        console.log(outputJson);
        this.rowData = outputJson.itemstocks;

        setTimeout(() => {
          this.searchByKey();
          this.gridOptions.api.hideOverlay();
          this.working = false;
        }, 100);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  changeOwner(selectedOwnerId) {
    if (selectedOwnerId !== undefined) {
      this.ownerId = selectedOwnerId;

      if (sessionStorage.getItem('ownerResult'))
        this.searchKeyOwnerTx = JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx;
    } else {
      this.ownerId = null;
      this.rowData = [];
      this.gridOptions.api.deselectAll();
      this.searchKeyOwnerTx = '';
      this.gridOptions.api.setFilterModel(null);
    }
    setTimeout(() => {
      this.onSubmit();
    }, 1500);
  }

  ngDoCheck() {
    this.searchValue1Cls = this.itemCd != null && this.itemCd !== '' ? 'active' : '';
    this.stockTypeCls = this.stockType != null && this.stockType == '' ? '' : 'active';
  }

  clearSearchKey() {
    this.errorInfo = '';

    this.itemCd = '';
    this.stockType = '';
    this.stockTypeCls = '';
  }

  searchByKey() {
    var filters = {};

    if (this.itemCd != null && this.itemCd.length > 0) {
      filters['itemCd'] = {
        type: 'contains',
        filter: this.itemCd
      };
    }

    if (this.searchKeyOwnerTx != null && this.searchKeyOwnerTx.length > 0) {
      filters['ownerTx'] = {
        type: 'contains',
        filter: this.searchKeyOwnerTx
      };
    }

    if (this.stockType != null && this.stockType.length > 0) {
      filters['typestockTx'] = {
        type: 'equals',
        filter: this.stockTypes[this.stockType]['typestockTx']
      };
    }
    this.gridOptions.api.setFilterModel(null);

    if (Object.getOwnPropertyNames(filters).length == 0) return;

    this.gridApi.api.setFilterModel(filters);
  }

  clearFilter() {
    this.errorInfo = '';

    this.gridOptions.api.setFilterModel(null);
  }

  clearAndSubmit() {
    this.clearFilter();
    this.onSubmit();
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  goto6010() {
    if (!this.isEnableGo6010Button)
      return;

    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      return;
    }

    var node = this.gridOptions.api.getSelectedNodes()[0];
    var itemCd = node.data.itemCd;
    sessionStorage.setItem('wa6030_itemId', itemCd);
    this.router.navigate(['wa6010']);
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6030/wa6030.component.ts